/* eslint-disable no-plusplus */
import { Backdrop, CircularProgress } from '@mui/material';
import { useEffect, useRef } from 'react';

let count = 0;
export function Loading() {
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    timeoutRef.current = window.setTimeout(() => {
      const el = document.getElementById('LoadingApp');
      if (el && count === 0) el.style.display = 'none';
    }, 5000);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <>
      <Backdrop
        id="LoadingApp"
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, display: 'none' })}
        open
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

Loading.Show = () => {
  count++;
  requestAnimationFrame(() => {
    const el = document.getElementById('LoadingApp');
    if (el) el.style.display = 'flex';
  });
};

Loading.Hide = () => {
  count = Math.max(0, count - 1);
  requestAnimationFrame(() => {
    const el = document.getElementById('LoadingApp');
    if (el && count === 0) el.style.display = 'none';
  });
};
